import { render } from "./add.subgl.vue?vue&type=template&id=6ba3bb62&lang=html"
import script from "./add.subgl.vue?vue&type=script&lang=js"
export * from "./add.subgl.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__